<template>
  <div class="card lista">
    <a href="javascript:" class="card-body text-decoration-none text-primary lista__link" :class="{'d-flex align-items-center': icone}" @click="go(url)">
      <div>
        <h6 class="mb-0 font-weight-bold text-uppercase">{{ nome }}</h6>
        <slot/>
      </div>
      <div class="ml-auto text-center lista__arrow" v-if="icone">
        <i class="fa-solid fa-chevron-right"></i>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Lista',
  props: ['nome', 'descricao', 'icone', 'url', 'id', 'external'],

  methods: {
    go(url) {
      if (url) {
        if (this.external) {
          window.open(url, '_blank')

        } else {
          this.$router.push(url);
        }

      } else {
        this.$emit('go', this.id)
      }
    }
  }
}
</script>

<style scoped>
.lista {
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

.lista__link {
  position: relative;
  overflow: hidden;
  border-radius: inherit;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.lista__link::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.08) 50%, rgba(255, 255, 255, 0) 70%);
  opacity: 0;
  transition: opacity 0.18s ease;
  pointer-events: none;
}

.lista__arrow {
  transition: transform 0.2s ease, color 0.2s ease;
}

.lista:hover,
.lista:focus-within {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(20, 35, 70, 0.1);
  border-color: var(--primary);
}

.lista:hover .lista__link,
.lista:focus-within .lista__link {
  background-color: var(--bg-theme-secondary);
}

.lista:hover .lista__link::after,
.lista:focus-within .lista__link::after {
  opacity: 1;
}

.lista:hover .lista__arrow,
.lista:focus-within .lista__arrow {
  transform: translateX(2px);
  color: var(--primary);
}

.dark-mode .lista:hover .lista__link,
.dark-mode .lista:focus-within .lista__link {
  background-color: var(--bg-elevated-soft);
}
</style>
